module.exports = __webpack_public_path__ + "videos/timelapse_desktop.0f550f1.mp4";